import { GenerateFiniteStateObservableHookFromIterableWithPauseWorkflow } from '../iterable/hook-generators';
export function GenerateFiniteStateObservableHookFromReadableStreamWithPauseWorkflow(stream) {
    return GenerateFiniteStateObservableHookFromReadableStreamReaderWithPauseWorkflow(stream.getReader());
}
export function GenerateFiniteStateObservableHookFromReadableStreamReaderWithPauseWorkflow(reader) {
    return GenerateFiniteStateObservableHookFromIterableWithPauseWorkflow((async function* () {
        let result;
        while (!(result = await reader.read()).done) {
            yield result.value;
        }
    })(), true);
}
//# sourceMappingURL=hook-generators.js.map